import { all, fork, put, take } from 'redux-saga/effects';

import { NORMALIZE_ALL, SAVE_ANNOTATIONS } from './actions';
import { SAVE_FILTER_MARKER_COLORS } from 'Reducers/compModels';
import {
  bookmarks as nmBookmarks,
  highlightsAndNotes as nmHighlightsAndNotes,
  markers as nmMarkers
} from 'Lib/normalizers';
import notebookFilterMarkers from 'Lib/notebookFilterMarkers';


function* normalizeAll() {
  const { data:{ vsBookmarks, vsHighlightsAndMarkers } } = yield take(NORMALIZE_ALL);
  const { highlights, markers } = vsHighlightsAndMarkers;

  yield fork(nmMarkers, markers);

  const [bookmarks, highlightsAndNotes] = yield all([
    nmBookmarks(vsBookmarks),
    nmHighlightsAndNotes(highlights)
  ]);

  yield fork(notebookFilterMarkers, highlightsAndNotes[0], markers);
  yield put({ type: SAVE_ANNOTATIONS, data: [bookmarks, highlightsAndNotes] });
}


export default normalizeAll;
